import React, { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { CenterSpin } from '../components/CenterSpin';
import { useAccessibleTeams } from '../contexts/AccessibleTeamsContext';

export const TeamLayout: React.FC = () => {
  const theme = useTheme();
  const { teamId } = useParams<{ teamId: string }>();
  const navigate = useNavigate();
  const { teams, isLoading, error } = useAccessibleTeams();

  useEffect(() => {
    if (!isLoading && teamId) {
      // Check if user has access to this team
      const hasAccess = teams.some((team) => team.teamId === teamId);

      if (!hasAccess && teams.length > 0) {
        // Redirect to first available team if no access
        void navigate(`/team/${teams[0].teamId}`, { replace: true });
      }
    }
  }, [teamId, teams, isLoading, navigate]);

  if (isLoading) {
    return <CenterSpin />;
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: `${theme.marginXL}px` }}>
        <h2>Error loading teams</h2>
        <p>{error.message}</p>
      </div>
    );
  }

  // Check if user has access to current team
  const hasAccess = teams.some((team) => team.teamId === teamId);
  if (!hasAccess && teams.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: `${theme.marginXL}px` }}>
        <h2>No Teams Available</h2>
        <p>You are not a member of any teams.</p>
      </div>
    );
  }

  return <Outlet />;
};
